import React, { Component } from "react";
import Header from "../component/Header";
import Breadcrumb from "../component/Breadcumb";
import Footer from "../component/Footer";

import apc from "../assets/img/modules/apc.png"
import tr from "../assets/img/modules/tr.png"
import ta from "../assets/img/modules/ta.png"
import sr from "../assets/img/modules/sr.png"
import sa from "../assets/img/modules/sa.png"
import ic from "../assets/img/modules/ic.png"
import cm from "../assets/img/modules/cm.png"
import holiday from "../assets/img/modules/holiday.png"
import op from "../assets/img/modules/op.png"
import em from "../assets/img/modules/em.png"
import ap from "../assets/img/modules/ap.png"
import rc from "../assets/img/modules/rc.png"
import ms from "../assets/img/modules/ms.png"

class Modules extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        document.title = "Modules - My Jainism";
    }

    render() {
        return (
            <React.Fragment>
                <Header />
                <Breadcrumb title={"Our Modules"} />
                <section className="service-section space">
                    <div className="container">
                        <div className="row gy-30">
                            <div className="col-lg-3 col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="service-box" data-overlay="title" data-opacity="6">
                                    <div className="service-img" >

                                    </div>
                                    <div className="service-content">
                                        <div className="service-icon">
                                            <img src={apc} alt="icon" />
                                        </div>
                                        <h3 className="service-title">Application Control Panel</h3>
                                        <p className="service-text">Dynamically benchmark seamless growth strategies via multidisciplinary initiatives. Credibly brand collaborative.</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="service-box" data-overlay="title" data-opacity="6">
                                    <div className="service-img">

                                    </div>
                                    <div className="service-content">
                                        <div className="service-icon">
                                            <img src={tr} alt="icon" />
                                        </div>
                                        <h3 className="service-title">Teacher Registration</h3>
                                        <p className="service-text">Dynamically benchmark seamless growth strategies via multidisciplinary initiatives. Credibly brand collaborative.</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="service-box" data-overlay="title" data-opacity="6">
                                    <div className="service-img">

                                    </div>
                                    <div className="service-content">
                                        <div className="service-icon">
                                            <img src={ta} alt="icon" />
                                        </div>
                                        <h3 className="service-title">Teacher Attendance</h3>
                                        <p className="service-text">Dynamically benchmark seamless growth strategies via multidisciplinary initiatives. Credibly brand collaborative.</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="service-box" data-overlay="title" data-opacity="6">
                                    <div className="service-img">

                                    </div>
                                    <div className="service-content">
                                        <div className="service-icon">
                                            <img src={sr} alt="icon" />
                                        </div>
                                        <h3 className="service-title">Student Registration</h3>
                                        <p className="service-text">Dynamically benchmark seamless growth strategies via multidisciplinary initiatives. Credibly brand collaborative.</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="service-box" data-overlay="title" data-opacity="6">
                                    <div className="service-img">

                                    </div>
                                    <div className="service-content">
                                        <div className="service-icon">
                                            <img src={sa} alt="icon" />
                                        </div>
                                        <h3 className="service-title">Student Attendance</h3>
                                        <p className="service-text">Dynamically benchmark seamless growth strategies via multidisciplinary initiatives. Credibly brand collaborative.</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="service-box" data-overlay="title" data-opacity="6">
                                    <div className="service-img">

                                    </div>
                                    <div className="service-content">
                                        <div className="service-icon">
                                            <img src={ic} alt="icon" />
                                        </div>
                                        <h3 className="service-title">Icard</h3>
                                        <p className="service-text">Dynamically benchmark seamless growth strategies via multidisciplinary initiatives. Credibly brand collaborative.</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="service-box" data-overlay="title" data-opacity="6">
                                    <div className="service-img">

                                    </div>
                                    <div className="service-content">
                                        <div className="service-icon">
                                            <img src={cm} alt="icon" />
                                        </div>
                                        <h3 className="service-title">Class Management</h3>
                                        <p className="service-text">Dynamically benchmark seamless growth strategies via multidisciplinary initiatives. Credibly brand collaborative.</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="service-box" data-overlay="title" data-opacity="6">
                                    <div className="service-img">

                                    </div>
                                    <div className="service-content">
                                        <div className="service-icon">
                                            <img src={holiday} alt="icon" />
                                        </div>
                                        <h3 className="service-title">Holidays</h3>
                                        <p className="service-text">Dynamically benchmark seamless growth strategies via multidisciplinary initiatives. Credibly brand collaborative.</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="service-box" data-overlay="title" data-opacity="6">
                                    <div className="service-img">

                                    </div>
                                    <div className="service-content">
                                        <div className="service-icon">
                                            <img src={op} alt="icon" />
                                        </div>
                                        <h3 className="service-title">Online Payment Integration</h3>
                                        <p className="service-text">Dynamically benchmark seamless growth strategies via multidisciplinary initiatives. Credibly brand collaborative.</p>

                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="service-box" data-overlay="title" data-opacity="6">
                                    <div className="service-img">

                                    </div>
                                    <div className="service-content">
                                        <div className="service-icon">
                                            <img src={em} alt="icon" />
                                        </div>
                                        <h3 className="service-title">Event Management</h3>
                                        <p className="service-text">Dynamically benchmark seamless growth strategies via multidisciplinary initiatives. Credibly brand collaborative.</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="service-box" data-overlay="title" data-opacity="6">
                                    <div className="service-img">

                                    </div>
                                    <div className="service-content">
                                        <div className="service-icon">
                                            <img src={ap} alt="icon" />
                                        </div>
                                        <h3 className="service-title">Aaradhna Patrak</h3>
                                        <p className="service-text">Dynamically benchmark seamless growth strategies via multidisciplinary initiatives. Credibly brand collaborative.</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="service-box" data-overlay="title" data-opacity="6">
                                    <div className="service-img">

                                    </div>
                                    <div className="service-content">
                                        <div className="service-icon">
                                            <img src={rc} alt="icon" />
                                        </div>
                                        <h3 className="service-title">Report Card</h3>
                                        <p className="service-text">Dynamically benchmark seamless growth strategies via multidisciplinary initiatives. Credibly brand collaborative.</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4 wow fadeInUp" data-wow-delay="0.1s">
                                <div className="service-box" data-overlay="title" data-opacity="6">
                                    <div className="service-img">

                                    </div>
                                    <div className="service-content">
                                        <div className="service-icon">
                                            <img src={ms} alt="icon" />
                                        </div>
                                        <h3 className="service-title">Marksheet</h3>
                                        <p className="service-text">Dynamically benchmark seamless growth strategies via multidisciplinary initiatives. Credibly brand collaborative.</p>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                <Footer />
            </React.Fragment>
        );
    }
}

export default Modules;
